import ShareAuth from '@link/share/vendors/firebase';
import { auth } from '@link/triplabo/stores';

const triplaboAuth = new ShareAuth(auth);

export default triplaboAuth;
